import { WhiteBox } from "@foodpilot/foods";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { MainContentLayout } from "src/components/Layout/MainContentLayout";
import { useStrategy } from "src/context/Strategy/useStrategy";
import { PillarCard } from "./PillarCard";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";

export const StrategyList = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { strategy } = useStrategy();

    const pillars = strategy?.pillars ?? [];
    const visiblePillars = pillars.filter((pillar) => pillar.indicators.length > 0);
    const strategyDescription = strategy?.description?.trim();

    return (
        <MainContentLayout>
            <Stack flexDirection={"column"} gap={theme.spacing(1)} marginBottom={theme.spacing(4)}>
                <Typography variant="h1">{strategy?.name ?? t("settings.csr.title", "Strategy")}</Typography>
                {strategyDescription && (
                    <Typography variant="body-medium" sx={{ whiteSpace: "pre-line" }}>
                        {strategyDescription}
                    </Typography>
                )}
            </Stack>
            <WhiteBox>
                {visiblePillars.length === 0 ?
                    <Box padding={theme.spacing(5)}>
                        <Stack alignItems={"center"}>
                            <Typography variant="h2">
                                {t("csrstrategy.page.no_pillars", { defaultValue: "No pillars" })}
                            </Typography>
                        </Stack>
                    </Box>
                :   <Fragment>
                        <Box padding={theme.spacing(5)}>
                            <Typography variant="h2">
                                {t("csrstrategy.page.pillarinfo")}
                                <span style={{ fontWeight: 400 }}>{` - ${visiblePillars.length}`}</span>
                            </Typography>
                        </Box>
                        <Box borderTop={`1px solid ${theme.custom.grey[500]}`} />
                        <Stack flexDirection={"column"}>
                            {visiblePillars.map((pillar, index) => {
                                return (
                                    <Fragment key={`visible-pillar-list-${pillar.id}`}>
                                        <Box padding={theme.spacing(5)}>
                                            <PillarCard pillar={pillar} pillarNumber={index + 1} />
                                        </Box>
                                        {index < visiblePillars.length - 1 && (
                                            <Box paddingX={theme.spacing(5)}>
                                                <Box borderTop={`1px solid ${theme.custom.grey[500]}`} />
                                            </Box>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </Stack>
                    </Fragment>
                }
            </WhiteBox>
        </MainContentLayout>
    );
};
